import request from './request';

export default {
	async getBookingGuidelines() {
		const res = await request.get('/app/booking-guidelines');
		return res;
	}
};
